module.exports = __webpack_public_path__ + "static/media/empty-food-responsive.dbd77a36.png";